<template>
	<div class="data-content">
		<div class="searchbar">
			<div class="pr10">
				<input style="display: none" ref="uploadExcel" type="file" id="uploadExcel" @change="uploadHandle($event)" />
				<el-button type="primary" size="small" class="table-toolbar-btn" @click="handleClear" v-if="perms.includes('home:parts:number:clear')">
					清空
				</el-button>
				<el-button
					type="primary"
					size="small"
					class="table-toolbar-btn"
					@click="handleBack"
					v-if="perms.includes('home:parts:number:bk') && isShowBack">
					回退
				</el-button>
				<el-button type="primary" size="small" class="table-toolbar-btn" @click="handleImport" v-if="perms.includes('home:parts:number:import')">
					导入
				</el-button>
				<el-button
					type="primary"
					size="small"
					class="table-toolbar-btn template-btn"
					@click="handleTemplate"
					v-if="perms.includes('home:parts:number:import')">
					模板下载
				</el-button>
			</div>
			<el-form ref="form" :inline="true" label-width="86px" size="small" :show-message="false" class="search-form">
				<el-form-item label="关键字">
					<el-input v-model="searchKey" clearable placeholder="请输入关键字"></el-input>
				</el-form-item>
				<el-button class="search-btn" @click="getDataList"></el-button>
				<el-button icon="el-icon-refresh-right" class="refresh-btn" @click="handleReset"></el-button>
			</el-form>
		</div>
		<div class="data-list-box">
			<el-table
				:data="dataList"
				:row-class-name="tableRowClassName"
				:header-cell-style="{ color: '#444' }"
				class="scroll-table"
				border
				style="width: 100%">
				<el-table-column prop="pcilNumberCode" label="零件名称（英文）"></el-table-column>
				<el-table-column prop="partNumberNew" label="最新编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="partNumberOld" label="历史编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="pcilNumberDate" label="发布时间" width="150"></el-table-column>
			</el-table>
			<div class="pagination-wrapper pa25">
				<Pagination
					:page.sync="pageNo"
					:pageSize.sync="pageSize"
					:total="total"
					@sizeChange="handleSizeChange"
					@currentChange="handleCurrentChange"></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
	components: {
		Pagination,
	},
	data() {
		return {
			// 权限
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			dataList: [],
			searchKey: "",
			pageNo: 1,
			pageSize: 10,
			total: 0,
			// 是否显示回退按钮
			isShowBack: false,
		};
	},
	created() {
		this.getDataList();
		this.checkBack();
	},
	computed: {},
	methods: {
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		formatTimestamp(ms, datetime) {
			const _fmt = datetime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD";
			return this.$moment(new Date(ms)).format(_fmt);
		},
		handleSizeChange() {
			this.getDataList();
		},
		handleCurrentChange() {
			this.getDataList();
		},
		// 查询
		handleSearch() {
			this.pageNo = 1;
			this.getDataList();
		},
		// 重置查询条件
		handleReset() {
			this.pageNo = 1;
			this.searchKey = "";
			this.getDataList();
		},
		// 获取数据
		getDataList() {
			let that = this;
			that.$request.post(
				"dataPartNumberList",
				true,
				{
					searchKey: that.searchKey,
					pageNo: that.pageNo,
					pageSize: that.pageSize,
				},
				function (r) {
					if (r.code == "0") {
						that.dataList = r.data.list;
						that.total = r.data.totalCount;
					} else {
						that.$message.error(r.msg);
					}
				},
				function () {},
			);
		},
		// 检查回退
		checkBack() {
			let that = this;
			that.$request.get("dataPartNumberCheckBk", true, {}, function (r) {
				if (r.code == "0") {
					that.isShowBack = (r.data || 0) > 0;
				}
			});
		},
		// 导入
		handleImport() {
			let el = document.getElementById("uploadExcel");
			el.click();
		},
		// 上传
		uploadHandle(e) {
			let file = e.target.files[0];
			if (file) {
				// if(window.sessionStorage.getItem('userInfo').superAdminFlag == '1' && file.size/1024/1024/1024 > 1) {
				// 	this.$message.error('导入文件不能大于1GB');
				// 	return
				// }
				// // 2022-07-31 应客户要求改为200M
				// if(window.sessionStorage.getItem('userInfo').superAdminFlag != '1' && file.size/1024/1024 > 200) {
				// 	this.$message.error('导入文件不能大于200MB');
				// 	return
				// }
				if (file.name.includes(".xlsx")) {
					let formdata = new FormData();
					formdata.append("file", file);
					let that = this;
					that.$request.initUploadExcel(formdata, "dataPartNumberUpload", true).then((data) => {
						if (data.code == 0) {
							that.pageNo = 1;
							that.getDataList();
							if (data.data.length > 0) {
								that.visible = true;
								that.errorList = data.data;
							} else {
								that.$message.success("导入成功");
							}
						}
					});
				} else {
					this.$message.error("文件格式不正确");
				}
			} else {
				this.$message.error("请选择上传的文件");
			}
			this.$refs.uploadExcel.value = "";
		},
		// 清空
		handleClear() {
			this.$confirm("确定要清空所有数据吗?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.get("dataPartNumberClear", true, {}, function (r) {
						if (r.code == "0") {
							that.getDataList();
							that.$message.success("操作成功");
						} else {
							that.$message.error(r.msg);
						}
					});
				})
				.catch(() => {});
		},
		// 回退
		handleBack() {
			this.$confirm("确定要回退上一个版本吗?", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request.get("dataPartNumberReturnBk", true, {}, function (r) {
						if (r.code == "0") {
							that.getDataList();
							that.$message.success("操作成功");
						} else {
							that.$message.error(r.msg);
						}
					});
				})
				.catch(() => {});
		},
		// 模板下载
		handleTemplate() {
			const linkNode = document.createElement("a");
			linkNode.style.display = "none";
			linkNode.href = "/static/template/PARTS-CODE-DATA.xlsx";
			linkNode.download = "PARTS-CODE-DATA.xlsx";
			document.body.appendChild(linkNode);
			linkNode.click(); //模拟在按钮上的一次鼠标单击
			URL.revokeObjectURL(linkNode.href); // 释放URL 对象
			document.body.removeChild(linkNode);
		},
	},
};
</script>

<style lang="scss" scoped>
.block {
	display: block;
}

.data-content {
	.top-box {
		// height: 32px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
	}

	.add-btn {
		display: inline-block;
		width: 66px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: #117ffc;
		border-radius: 4px;
		color: #fff;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.import-btn {
		display: inline-block;
		width: 66px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.template-btn {
		display: inline-block;
		width: 88px;
		height: 32px;
		line-height: 32px;
		border: none;
		background-color: rgba(17, 127, 252, 0.2);
		border-radius: 4px;
		color: #117ffc;
		font-size: 15px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
	}

	.top-right-box {
		display: flex;
		flex-direction: row;
		align-items: center;

		.label {
			font-size: 14px;
			color: #606266;
			margin-right: 5px;
		}

		.search-select {
			width: 200px;
			margin: 0 10px;
		}

		.search-input {
			width: 138px;
			margin: 0 10px;
		}

		.search-btn {
			width: 32px;
			vertical-align: middle;
			cursor: pointer;
		}

		.refresh-btn {
			width: 32px;
			height: 32px;
			border: none;
			color: #117ffc;
			padding: 0;
			background-color: rgba(17, 127, 252, 0.2);
			font-weight: bold;
			font-size: 22px;
			vertical-align: bottom;
			margin-left: 5px;
		}

		::v-deep .el-input__inner {
			height: 32px;
			line-height: 32px;
		}

		::v-deep .el-input__icon {
			line-height: 32px;
		}

		::v-deep .el-range-editor.el-input__inner {
			padding: 0 3px;
		}
	}

	.btn-blue {
		font-size: 12px;
		font-weight: bold;
		color: #1081fd;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}

	.btn-red {
		font-size: 12px;
		font-weight: bold;
		color: #e9515e;
		text-decoration: underline;
		border: none;
		cursor: pointer;
		background-color: #fff;
		margin-right: 10px;
	}
}

.dialog-title {
	display: block;
	text-align: center;

	span {
		color: #222;
		font-weight: 600;
		font-size: 20px;
	}

	img {
		width: 28px;
		float: right;
		cursor: pointer;
	}
}

.error-list {
	height: 50vh;
	box-sizing: border-box;
	padding: 20px;
	overflow: auto;

	li {
		list-style: none;
	}
}

.searchbar {
	.el-date-editor--daterange.el-input,
	.el-date-editor--daterange.el-input__inner {
		width: 228px;
	}

	.table-toolbar-btn {
		margin-left: 0;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	.template-btn {
		width: unset;
		vertical-align: bottom;
		padding: 0 15px;
	}
}

.search-btn {
	float: unset !important;
	border: none;
	padding: 0 !important;
	margin: 0 !important;
	margin-left: 10px !important;
	vertical-align: top;
}

.refresh-btn {
	width: 32px;
	height: 32px;
	border: none;
	color: #117ffc;
	padding: 0;
	background-color: rgba(17, 127, 252, 0.2);
	font-weight: bold;
	font-size: 22px;
	vertical-align: 8px;
	margin-left: 5px;

	&:hover {
		background-color: rgba(17, 127, 252, 0.3);
	}
}

@media screen and (max-width: 1998px) {
	.search-form {
		max-width: 980px;
	}
}

@media screen and (max-width: 1113px) {
	.search-form {
		max-width: 444px;
	}
}

@media screen and (max-width: 723px) {
	.search-form {
		max-width: 312px;
	}
}

.dt-picker {
	min-width: 190px;
}
</style>

<style>
.el-table__fixed-right::before {
	background-color: transparent !important;
}

.scroll-table {
	border: 1px solid #dcdfe6;
}

.scroll-table .yellow {
	background-color: rgba(255, 255, 255);
}

.scroll-table .blue {
	background-color: rgba(246, 249, 253);
}
</style>
